export default __webpack_public_path__ + "static/media/ui_ux_friendly.1f0a1a53.png";